import styled from 'styled-components';
import {
  MARGIN,
  REBRAND_COLOR,
  PADDING,
  BREAKPOINT
} from '@latitude/core/utils/constants';
import { Box, Flex } from '@latitude/box';
import Icon from '@latitude/svg-inline/images/external-link.svg';
import Section from '@latitude/section-rebrand';

export const Wrapper = styled.div`
  background-color: ${REBRAND_COLOR.STONE};
`;

export const StyledDigitalWalletContainer = styled(Section)`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 16px;
  background-color: ${REBRAND_COLOR.STONE};
  padding-top: ${PADDING.P64};
  padding-bottom:${PADDING.P64};
`;

export const StyledLinkItems = styled(Flex)`
  margin-top: ${MARGIN.M32};
  flex-wrap: wrap;
  justify-content: center;

  a {
    margin: ${MARGIN.M16} calc(${MARGIN.M16} / 2) 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 48px;
    border-radius: 4px;
    background: ${REBRAND_COLOR.WHITE};
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
    border-bottom: none;
    &:hover {
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
      border-bottom: none;
    }
    @media (min-width: ${BREAKPOINT.LG}) {
      max-width: 180px;
    }

    ${props =>
      props.noShadow &&
      `box-shadow: none; background: none;
      &:hover { box-shadow: none;  border-bottom: none; }`}
  }
`;

export const StyledIcon = styled(Icon)`
  fill: ${REBRAND_COLOR.INDIGO};
  margin-left: ${MARGIN.M16};
`;
